module.exports = __webpack_public_path__ + "media/img/favicon/mstile-310x310-cc709425cadbbf0818f3ab54764d7f50.png";